import serviceReducer from './serviceSlice';
import * as serviceActions from './actions';
import * as serviceSelector from './selector';

export {
  serviceActions,
  serviceSelector
}

export default serviceReducer